import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'polaris-lib-limits.title',
		defaultMessage: 'Unavailable',
		description: 'Title for the entity limit popup',
	},
});
